import * as React from "react";

const MicrophoneIcon = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 3a2.5 2.5 0 1 1 5 0v5.5a2.5 2.5 0 0 1-5 0V3Z"
      fill="#95959E"
    />
    SvgComponent SvgComponent
    <path
      d="M4 7a.5.5 0 0 1 .5.5v1a3.5 3.5 0 0 0 7 0v-1a.5.5 0 0 1 1 0v1a4.5 4.5 0 0 1-4 4.473V14.5h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2v-1.527a4.501 4.501 0 0 1-4-4.473v-1A.5.5 0 0 1 4 7Z"
      fill="#95959E"
    />
  </svg>
);

export default MicrophoneIcon;
